import { getErrorMessage } from '@/api/http/getErrorMessage'
import { runDetached } from '@/shared/lib/runDetachedPromise'

export function runWebSurveyEmailAvailabilityCheck(
  mutateAsync: (email: string) => Promise<unknown>,
  email: string,
  onSuccess: () => void,
  onError: (message: string) => void,
): void {
  runDetached(
    mutateAsync(email).then(
      () => {
        onSuccess()
      },
      (err) => {
        onError(getErrorMessage(err))
      },
    ),
  )
}
